import Cookies from "js-cookie";

// MyAppList Functions
function updateMyAppList(app) {
  const toggleButtons = document.querySelectorAll(
    '.myapplist__toggle[data-app-id="' + app + '"]'
  );
    
  let myapplistData = Cookies.get("Drupal_visitor_myapplist")
  ? JSON.parse(Cookies.get("Drupal_visitor_myapplist"))
  : new Array();
  
  if (isInMyAppList(app)) {

    // if app is in list, delete it
    const appPos = myapplistData.findIndex((index) => index === app);
    myapplistData.splice(appPos, 1);
    Cookies.set("Drupal_visitor_myapplist", JSON.stringify(myapplistData), {
      expires: 7,
    });

    toggleButtons.forEach(toggleBtn => {
      toggleBtn.classList.remove('in_myapplist');
      toggleBtn.innerText = "Add to List";
    });

    // Change toggle button to blue

    // Trigger event
    const event = new CustomEvent("myapplist.changed", {
      detail: "An app has been deleted from MyAppList",
    });
    document.dispatchEvent(event);
  } else {

    // if app is not in list, lets add it
    myapplistData.push(app);
    Cookies.set("Drupal_visitor_myapplist", JSON.stringify(myapplistData), {
      expires: 7,
    });

    // Change toggle button to red
    toggleButtons.forEach(toggleBtn => {
      toggleBtn.classList.add('in_myapplist');
      toggleBtn.innerText = "Remove from List";
    });

    // Trigger event
    const event = new CustomEvent("myapplist.changed", {
      detail: "An app has been added to MyAppList",
    });
    document.dispatchEvent(event);
  }
}

function isInMyAppList(app) {
  if (Cookies.get("Drupal_visitor_myapplist") === undefined) return false;

  const myapplistData = JSON.parse(Cookies.get("Drupal_visitor_myapplist"));

  if (!Array.isArray(myapplistData) || myapplistData.length == 0) {
    return false;
  } else {
    return myapplistData.includes(app);
  }
}

function getMyAppList() {
  return Cookies.get('Drupal_visitor_myapplist') ? Cookies.get('Drupal_visitor_myapplist') : false;
}

export default {
	updateMyAppList,
	isInMyAppList,
  getMyAppList,
};